import { Component, OnInit, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ComponentBase } from 't4core';
import { DisplayMode, LayoutService } from '../../Services/LayoutService/layout.service';

@Component({
    selector: 'app-view-title',
    template: '',
    standalone: false
})
export class ViewTitleComponent extends ComponentBase implements OnInit, OnDestroy {

  @Input() public Title: string;

  @Input() public showHeader: boolean;
  @Input() public showBack: boolean;
  @Input() public showMenu: boolean;
  @Input() public overlay: boolean;

  @Input() public isPrimaryColor: boolean;
  @Input() public isSplitColor: boolean;
  @Input() public isSafeSignal: boolean;
  @Input() public isDangerSignal: boolean;

  @Input() public mode: DisplayMode;
  @Input() public webMode: DisplayMode;

  private isDisposed: boolean = false;

  constructor(private layout:LayoutService) { super(); }

  ngOnInit(): void {

    if (this.isPrimaryColor) this.mode = 'primary';
    if (this.isSplitColor) this.mode = 'split';
    if (this.isSafeSignal) this.mode = 'safe';
    if (this.isDangerSignal) this.mode = 'danger';
    
    setTimeout(() => {
      if (this.isDisposed) return;
      this.layout.update(
        {
          title: this.Title,
          mode: this.mode,
          webMode: this.webMode,
          header: {
            showBack: this.showBack,
            showMenu: this.showMenu,
            visible: this.showHeader,
            overlay: this.overlay
          }
        });
    }, 1);
  }

  ngOnDestroy(): void {
    this.isDisposed = true;
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.isPrimaryColor) this.mode = 'primary';
    if (this.isSplitColor) this.mode = 'split';
    if (this.isSafeSignal) this.mode = 'safe';
    if (this.isDangerSignal) this.mode = 'danger';


    setTimeout(() => {
      if (this.isDisposed) return;
      this.layout.update(
        {
          title: this.Title,
          mode: this.mode,
          webMode: this.webMode,
          header: {
            showBack: this.showBack,
            showMenu: this.showMenu,
            visible: this.showHeader,
            overlay: this.overlay,
          }
        });
    }, 100);
  }
}
